import { paramsSetUrl } from '@getpopsure/public-utility';
import routes from 'constants/routes';
import lz from 'lz-string';
import { GenericQuestionnaireState } from 'reducers/genericQuestionnaire';
import { isStagingOrDev } from 'shared/util/isStagingOrDev';

type ShareUrlProps = {
  questionnaireAnswers: Record<string, unknown>;
  verticalId: keyof GenericQuestionnaireState;
  seedId?: string;
  utmSource?: string;
  useStaging?: boolean;
};

export const getShareUrl = ({
  questionnaireAnswers,
  verticalId,
  seedId,
  utmSource,
  useStaging = false,
}: ShareUrlProps) => {
  const path = window.location.pathname;

  return path
    ? paramsSetUrl(
        `https://app.${
          isStagingOrDev && useStaging ? 'staging.' : ''
        }feather-insurance.com${routes.policies.seed.path}`,
        [
          {
            // p = Path
            key: 'p',
            // eslint-disable-next-line react/prop-types
            value: path,
          },
          // v = Values
          {
            key: 'v',
            value: lz.compressToEncodedURIComponent(
              JSON.stringify(questionnaireAnswers)
            ),
          },
          // t = Type
          // eslint-disable-next-line react/prop-types
          { key: 't', value: verticalId },
          // ver = Version
          { key: 'ver', value: '1' },
          // u = utm_source
          ...(utmSource ? [{ key: 'u', value: utmSource }] : []),
          ...(seedId ? [{ key: 's', value: seedId }] : []),
        ]
      )
    : undefined;
};
